import React from "react";
import { LockOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Input, Button, Spin, message } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { API } from "aws-amplify";
import AuthService from "../../Services/AuthService";
import { BaseAlphaUI } from "../..";

interface Props {
  changeState: (newState: string) => void;
  setError: (error: string) => void;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  form: any;
  initialLoginType?: "Password";
  error?: string;
}

interface State {
  loginType: "Password";
  loggingIn: boolean;
  loading: boolean;
  invalidLink: boolean;
}

class SignUp extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loginType: "Password",
      loggingIn: false,
      loading: true,
      invalidLink: false,
    };
  }
  setLoginType = (type: "Password"): void => {
    this.setState({
      loginType: type,
    });
  };
  signupWithPassword = (): void => {
    const { form } = this.props;
    this.setState({
      loggingIn: true,
    });
    form.validateFields(async (err: boolean, values: any) => {
      if (err) {
        this.setState({
          loggingIn: false,
        });
        return;
      }
      // Initiate Auth, and once we receive the challenge back, we can redirect the user
      const authService = new AuthService();
      try {
        let user;
        try {
          user = await authService.signupWithPassword(
            values.email,
            values.password
          );
        } catch (e) {
          if (e.code === "UsernameExistsException") {
            // Something broke with the user during sign up, try signing in
            user = await authService.loginWithPassword(
              values.email,
              values.password
            );
          } else {
            throw e;
          }
        }
        if (!user.userConfirmed) {
          this.props.setEmail(values.email);
          this.props.setPassword(values.password);
          this.props.changeState("verificationCode");
        } else {
          message.success("You have successfully signed up");
          window.location.href = "/";
        }
      } catch (e) {
        if (e.code === "UserNotConfirmedException") {
          // In case we tried logging in but failed because not confirmed
          this.props.setEmail(values.email);
          this.props.setPassword(values.password);
          this.props.changeState("verificationCode");
          return;
        }
        this.props.setError(e.message || "An error occurred");
        this.setState({
          loggingIn: false,
        });
      }
    });
  };
  goToSignin = (): void => {
    this.props.changeState("signIn");
  };
  handleKeyPress = () => {
    console.log("event");
    this.signupWithPassword();
  };
  async componentDidMount() {
    // Get email from token
    const apiName = BaseAlphaUI.getAuthApiName();
    const appName = BaseAlphaUI.getAppName();
    try {
      const response = await API.get(apiName, "/invite", {
        queryStringParameters: {
          type: window.localStorage.getItem(`${appName}InviteType`),
          token: window.localStorage.getItem(`${appName}InviteToken`),
        },
      });
      this.setState({ loading: false }, () => {
        this.props.form.setFieldsValue({ email: response.email });
      });
    } catch (e) {
      console.error(e);
      this.props.setError(
        "There seems to be an issue with your invitation, please contact your system administrator. If you have already signed up, please go to sign in using the button below."
      );
      this.setState({ loading: false, invalidLink: true });
    }
  }
  render(): React.ReactElement {
    const { getFieldDecorator } = this.props.form;
    const { loggingIn } = this.state;
    return (
      <Form>
        <h2>Sign Up</h2>
        {this.state.loading ? (
          <div style={{ textAlign: "center" }}>
            <Spin />
          </div>
        ) : (
          !this.state.invalidLink && (
            <>
              <FormItem>
                {getFieldDecorator("email", {
                  rules: [
                    { required: true, message: "Please input your email!" },
                  ],
                })(<Input placeholder="Email" readOnly />)}
              </FormItem>

              {this.state.loginType === "Password" && (
                <FormItem>
                  {getFieldDecorator("password", {
                    rules: [
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ],
                  })(
                    <Input
                      prefix={<LockOutlined style={{ fontSize: 13 }} />}
                      type="password"
                      placeholder="Password"
                      onPressEnter={() => {
                        this.handleKeyPress();
                      }}
                    />
                  )}
                </FormItem>
              )}

              <FormItem>
                {this.state.loginType === "Password" && (
                  <>
                    <Button
                      disabled={loggingIn}
                      type="primary"
                      onClick={(): void => this.signupWithPassword()}
                      style={{ width: "100%" }}
                      loading={this.state.loggingIn}
                    >
                      Sign Up
                    </Button>
                    <br />
                    <br />
                  </>
                )}
                {this.state.loginType !== "Password" && (
                  <Button
                    disabled={loggingIn}
                    type="primary"
                    onClick={(): void => this.setLoginType("Password")}
                    style={{ width: "100%" }}
                  >
                    Sign up
                  </Button>
                )}
                Already have an account?{" "}
                <Button
                  disabled={loggingIn}
                  type="link"
                  onClick={this.goToSignin}
                >
                  Login
                </Button>
              </FormItem>
            </>
          )
        )}
        {this.state.invalidLink && (
          <Button
            type="primary"
            onClick={(): void => {
              window.location.href = "/";
            }}
          >
            Go to Login
          </Button>
        )}
      </Form>
    );
  }
}

const WrappedSignUp = Form.create<Props>()(SignUp);

export default WrappedSignUp;
